module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray@2x-b6b8343ca3c480cbd713395c0b7bd85b.png";